import React, { useContext } from 'react';
import EDView from '../../../../../../BaseComponents/View/EDView';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { GridContext } from '../../../../../GridContext';
import { VisningsTypContext } from '../VisningsTypContext/VisningsTypContext';

interface IProps {
  editContainer?: boolean;
}

const useStyles = makeStyles()(
  (theme: Theme) =>
    ({
      outerContainer: {
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'flex-start',
        [theme.breakpoints.only('xs')]: {
          flexDirection: 'column',
        },
      },
      griddedContainer: {
        boxSizing: 'border-box',
        padding: '8px',
        lineHeight: 1.25,
        width: '100%',
        '& p': {
          display: 'block',
          lineHeight: 1.2,
          margin: theme.spacing(0),
          padding: theme.spacing(0),
          verticalAlign: 'top',
          [theme.breakpoints.only('xs')]: {
            display: 'inline-block',
          },
        },
        '&:empty': {
          display: 'none',
        },
      },
      detailsRightGridded: {
        '& p': {
          display: 'inline-block',
        },
      },
      editContainer: {
        boxShadow: '0 0 0 1px rgb(0 0 0 / 12%)',
        borderRadius: theme.spacing(0.5),
      },
    } as const)
);

const AttributRad: React.FC<React.PropsWithChildren<IProps>> = props => {
  const { classes, cx } = useStyles();
  const gridContext = useContext(GridContext);
  const visningsTypContext = useContext(VisningsTypContext);

  return (
    <EDView
      className={cx({
        [classes.griddedContainer]: gridContext.inGrid,
        [classes.outerContainer]: !gridContext.inGrid,
        [classes.editContainer]: gridContext.inGrid && props.editContainer,
        [classes.detailsRightGridded]:
          gridContext.inGrid && visningsTypContext.showDetailsRight,
      })}
    >
      {props.children}
    </EDView>
  );
};

export default AttributRad;
